/**
 * Filter properties that are scoped to a specific department.
 * These filters will be cleared from localStorage when the user changes department,
 * because the available options (e.g., job positions, components) differ between departments.
 *
 * Add new properties here as needed when they reference department-specific data.
 */
export const DEPARTMENT_SCOPED_FILTER_PROPERTIES: string[] = [
  // Responsibility/access related (different positions, groups, roles, and users per department)
  'access',
  'accessPositions',
  'accessPositionGroups',
  'accessRoles',
  'responsible',
  'responsiblePositions',
  'responsiblePositionGroups',
  'responsibleRoles',
  'responsibleUsers',
  'responsibleOwnerPosition',
  'responsibleOwnerPositionGroup',
  'responsibleOwnerRole',
  'responsibleForFollowUp',
  'responsibleForFollowUpPositions',
  'responsibleForFollowUpPositionGroups',
  'responsibleForFollowUpRoles',
  'responsibleForFollowUpUsers',
  'responsibleForClosing',
  'responsibleForClosingPositions',
  'responsibleForClosingPositionGroups',
  'responsibleForClosingRoles',
  'responsibleForClosingUsers',
  'assignedTo',

  // Component related (different components per department)
  'componentName',
  'component',
  'placement',

  // Project related (projects are department-scoped)
  'project',

  // User related when filtered by department
  'user',
];
